import { ReactElement } from "react"

import AmendDeviceForm from "../../../../components/devices/ttr/amendDeviceForm"
import ContinueAmendmentProvider from "../../../../components/devices/ttr/providers/continueAmendmentProvider"

const ContinueDraftDeviceAmendment = (): ReactElement => (
    <ContinueAmendmentProvider>
        <AmendDeviceForm />
    </ContinueAmendmentProvider>
)

export default ContinueDraftDeviceAmendment
